import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((error: Error) => { // NOSONAR
    document.body.innerHTML = `<pre style="color: red;">Application failed to start: ${error.message}</pre>`;
});
